export enum FILE_PICK_STATUS {
  ACTIVE = 'ACTIVE',
  REVOKED = 'REVOKED',
}
